module.exports = __webpack_public_path__ + "static/media/close_gray.50528159.svg";